import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledSkeletonContainer = styled.div`
  margin: ${spacing.plusHalf};
  width: ${pxToRem(560)};
`;

const SkeletonFirstRow = styled(Skeleton)`
  margin-bottom: ${spacing.plusHalf};
`;
const SkeletonTextGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 135px;
  gap: ${spacing.half} ${spacing.quarter};
`;

export const UnscoredUnsubsubcribeMetricsSkeletonId = 'unscored-unsubscribe-skeleton';

export const UnscoredUnsubsubcribeMetricsSkeleton = () => {
  return (
    <StyledSkeletonContainer>
      <SkeletonFirstRow
        data-test={UnscoredUnsubsubcribeMetricsSkeletonId}
        width={520}
        height={12}
      />
      <SkeletonTextGrid>
        <Skeleton width={300} height={40} />
        <Skeleton width={135} height={16} />
        <Skeleton width={300} height={40} />
        <Skeleton width={135} height={16} />
        <Skeleton width={300} height={40} />
        <Skeleton width={135} height={16} />
      </SkeletonTextGrid>
    </StyledSkeletonContainer>
  );
};
